import { render, staticRenderFns } from "./BaseTag.vue?vue&type=template&id=0dbe623c&"
import script from "./BaseTag.vue?vue&type=script&lang=js&"
export * from "./BaseTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dbe623c')) {
      api.createRecord('0dbe623c', component.options)
    } else {
      api.reload('0dbe623c', component.options)
    }
    module.hot.accept("./BaseTag.vue?vue&type=template&id=0dbe623c&", function () {
      api.rerender('0dbe623c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseTag.vue"
export default component.exports